import "styles/pages/page-blog.scss";

import React from "react";

import Seo from "components/Seo";
import Layout from "components/Layout";
import SubpageHeader from "components/SubpageHeader";
import Breadcrumps from "components/Breadcrumps";

import { Content } from "page_components/blog";

import { usePosts } from "context/posts";

const CategoryContent = ({ pageContext }) => {
  const { posts } = usePosts();

  const pageData = pageContext.data;
  const slug = pageData?.slug;

  const breadcrumps_data = [
    {
      name: "Blog",
      href: "/blog/",
    },
    {
      name: pageData.name,
    },
  ];

  const current_posts = posts?.filter((item) =>
    item?.categories?.nodes?.some((category) => category?.slug === slug)
  );

  return (
    <>
      <Breadcrumps data={breadcrumps_data} />
      <SubpageHeader title={pageData.name} />
      <Content
        no_banner
        no_pagination={pageContext?.num_pages <= 1}
        category={slug}
        page_posts={current_posts}
        pageContext={pageContext}
      />
    </>
  );
};

const Category = ({ pageContext }) => {
  return (
    <Layout page>
      <CategoryContent pageContext={pageContext} />
    </Layout>
  );
};

export const Head = ({ pageContext }) => <Seo title={pageContext.data?.name} />;

export default Category;
